export default {
    contactUs: "Contact Us",
    aboutUs: "About Us",
    loremIpsum: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum quis consectetur odio. Donec arcu turpis, mollis sit amet blandit sit amet, rutrum sit amet ex.",
    products: "Products",
    link: "Link",
    italy: "Italy",
    or: "or",
    app: "App",
    purgerForPlex: "Purger for Plex",
    purgerForPlexSubtitle: "Automated Plex library cleanup.",
    purgerForPlexDescription: "A focused tool that helps you keep your Plex libraries tidy by removing stale or unwanted items with minimal effort.",
    purgerForPlexScreenshots: "Screenshots",
    purgerForPlexDescriptionTitle: "Description",
    graphia: "Graphia",
    palmy: "Palmy",
    plonty: "Plonty"
}
